export enum ReviewDone {
  StartProduction = 'Review Done: Start Production',
  SubmitToConf = 'Review Done: Submit to Conferences'
}
